<template>
  <div class="container-table">
    <q-card-section>
      <q-table
        title="Informe de declaración responsable de existencia de crédito"
        :data="declaraciones"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
      >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fechaSubida="props">
          <q-td key="fechaSubida" :props="props">
            {{ props.row.fechaSubida | shortDate }}
          </q-td>
        </template>

        <template v-slot:body-cell-url="props">
          <q-td key="url" :props="props">
            <a v-if="props.row.url" :href="props.row.url" download target="_blank">
              <q-icon :name="'img:' + require('@/assets/img/file-download-black-24-dp.svg')"></q-icon>
            </a>
          </q-td>
        </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar la declaración? ${rowSelectedtoDelete.nombre}`
      "
      @save="deleteDeclaracion()"
    />
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    DialogDelete
  },
  props: {
    isLoading: Boolean,
    declaraciones: Array
  },
  mixins: [Loading],
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      columns: [
        {
          name: 'nombre',
          label: 'Nombre informe',
          align: 'left',
          field: 'nombre',
          sortable: true
        },
        {
          name: 'fechaSubida',
          label: 'Fecha de subida',
          align: 'left',
          field: 'fechaSubida',
          sortable: true
        },
        {
          name: 'url',
          label: '',
          align: 'left',
          field: 'url',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteDeclaracion () {
      // obtenemos indice
      const index = this.declaraciones.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.declaraciones.splice(index, 1);
      this.showDialogDelete = false;
      this.$eventHub.$emit('vaciaFile');
      this.$eventHub.$emit('deleteFile', this.rowSelectedtoDelete);
      this.$eventHub.$emit('dirtyForm');
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
}
</style>
